import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export const quillConfig = {
    toolbar: {
        theme: 'snow',
        container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link'],
        ],
    },
};
@Component({
    selector: 'rs-html-notes',
    templateUrl: './html-notes.component.html',
    styles: [
        `
            @use 'tailwindcss/base';
            @use 'tailwindcss/components';
            @use 'tailwindcss/utilities';


            .card {
                padding: 1.5rem;
            }
        `,
    ],
    standalone: false
})
export class HtmlNotesComponent {
    @Input() public notes: any;
    @Input() public noteType: 'all' | 'patient' | 'visit';
    @Output() public edit: EventEmitter<any> = new EventEmitter<any>();
    @Output() public delete: EventEmitter<any> = new EventEmitter<any>();

    public editForm: UntypedFormGroup;
    public quillConfig = quillConfig;

    constructor(private readonly formBuilder: UntypedFormBuilder) {
    }

    public editNote(note: any) {
        note.mode = note.mode === 'view' ? 'edit' : 'view';

        this.editForm = this.formBuilder.group({
            note: this.formBuilder.control(note.notes, [Validators.required]),
            noteId: this.formBuilder.control(note.noteId, [Validators.required]),
        });
    }

    public saveEditedNote(): void {
        this.edit.emit(this.editForm);
    }

    public deleteNote(noteId: number): void {
        this.delete.emit(noteId);
    }
}
